

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Component, Inject } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { City } from '@/models/form/PersonalDetails.model';
import { Document, Documents } from '@/models/form/Documents.model';
import { Utils } from '@/globals/Utils';
import MockData from '@/globals/mock';
import { InputFile } from '@/models/InputFile.model';
import {
  FORM101_DATA,
  FORM101_META_DATA,
  FORM_READ_ONLY_MODE,
  DOWNLOAD_FORM_119,
  GET_SETTLEMENTS,
  SET_FORM101_DATA,
  SETTLEMENTS,
} from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import {
  DELETE_DOCUMENT,
  DOCUMENTS,
  DOCUMENTS_ERRORS,
  DOWNLOAD_DOCUMENT,
  SET_DOCUMENTS,
  UPLOAD_CLICKED,
} from '@/types/documents.types';
import { MaritalStatus } from '@/models/form/enum/MaritalStatus';
import { Gender } from '@/models/form/enum/Gender';
import { GET_MANAGER_DOCUMENT_CONTENT, MANAGER_MODE } from '@/types/managerForm.types';
import ExternalIncomeTableComponent from '@/views/dashboard/form101/steps/tax-details-step/external-income-table/external-income-table.component.vue'
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import { UPLOAD_FILE_ENABLE } from '@/types/lobby.types';

@Component({
  components: { ExternalIncomeTableComponent },
})
export default class TaxDetailsStep extends FeedbackComponent {
  @Inject() public $validator: any;

  @Action(UPLOAD_CLICKED, StoreNamespace.DOCUMENT) public uploadClicked;
  @Action(DELETE_DOCUMENT, StoreNamespace.DOCUMENT) public deleteDocument;
  @Action(DOWNLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public downloadDocument;
  @Action(GET_SETTLEMENTS, StoreNamespace.FORM) public getSettlements;
  @Action(GET_MANAGER_DOCUMENT_CONTENT, StoreNamespace.MANAGER) public managerDownloadDocument;
  @Action(DOWNLOAD_FORM_119, StoreNamespace.FORM) public getDownloadForm119;

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;
  @Mutation(SET_DOCUMENTS, StoreNamespace.DOCUMENT) public setDocuments;

  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(DOCUMENTS, StoreNamespace.DOCUMENT) public documents!: Documents;
  @Getter(SETTLEMENTS, StoreNamespace.FORM) public settlements!: City[];
  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode!: boolean;
  @Getter(DOCUMENTS_ERRORS, StoreNamespace.DOCUMENT) public documentsErrors!: string[];

  @Getter(UPLOAD_FILE_ENABLE, StoreNamespace.AUTHENTICATION) public uploadFileEnable!: boolean;

  public upload802FileModal = false;
  public upload8022FileModal = false;
  public upload803FileModal = false;
  public upload804FileModal = false;
  public upload805FileModal = false;
  public upload809FileModal = false;
  public upload810FileModal = false;
  public upload811FileModal = false;
  public upload813FileModal = false;
  public upload814FileModal = false;
  public upload851FileModal = false;
  public upload901FileModal = false;
  public upload902FileModal = false;
  public upload903FileModal = false;
  public upload816FileModal = false;
  public employeeAge = 0;
  public partnerAge = 0;
  private mockData: any = {};

  private inhabitantSettlementDate: any = null;
  private immigrationOrReturningDate: any = null;
  private noIncomeUntilDate: any = null;
  private serviceBeginDate: any = null;
  private serviceEndDate: any = null;

  public created() {
    if (this.form101Data.inhabitantSettlementDate) {
      this.inhabitantSettlementDate = Utils.stringToDate('' + this.form101Data.inhabitantSettlementDate);
    }
    if (this.form101Data.immigrationOrReturningDate) {
      this.immigrationOrReturningDate = Utils.stringToDate('' + this.form101Data.immigrationOrReturningDate);
    }
    if (this.form101Data.noIncomeUntilDate) {
      this.noIncomeUntilDate = Utils.stringToDate('' + this.form101Data.noIncomeUntilDate);
    }
    if (this.form101Data.serviceBeginDate) {
      this.serviceBeginDate = Utils.stringToDate('' + this.form101Data.serviceBeginDate);
    }
    if (this.form101Data.serviceEndDate) {
      this.serviceEndDate = Utils.stringToDate('' + this.form101Data.serviceEndDate);
    }

    if (this.form101Data.birthDate) {
      this.employeeAge = this.form101Data.taxYear - +this.form101Data.birthDate.toString().substring(0, 4);
    }
    if (this.form101Data.partnerBirthDate) {
      this.partnerAge = this.form101Data.taxYear - +this.form101Data.partnerBirthDate.toString().substring(0, 4);
    }
    this.getSettlements(this.form101Data.taxYear);

    if (this.form101Data.runTaxBenefitsAutoFill) {
      this.autoFill();
      this.updateForm101Data(false, 'runTaxBenefitsAutoFill');
    }
    this.mockData = MockData.form101;
  }

  public downloadForm119() {
    this.getDownloadForm119();
  }

  public updateForm101Data(newVal: any, property: string) {
    if (!newVal || property === 'taxCoordinate') {
      this.clearEmployeeFields(newVal, property);
    }
    if (property === 'inhabitantSettlement' && newVal) {
      this.getSettlements(this.form101Data.taxYear);
    }
    if (property === 'incompetentChild' && !newVal) {
      this.setForm101Data({ ...this.form101Data, ['incompetentChildrenCount']: null });
    }
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }

  public updateForm101DataWithCheckbox(newVal: any, property: string, checkboxProperty: string) {
    this.setForm101Data({ ...this.form101Data, [checkboxProperty]: +newVal > 0 });
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }

  public clearEmployeeFields(newVal: any, name: string) {
    switch (name) {
      case 'handicapped':
        this.documents.handicapFiles.forEach((file: Document) => {
          this.onRemovedClicked(file);
        });
        this.form101Data.handicappedWithMonthlyAllowance = false;
        this.documents.handicapMonthlyAllowanceFiles.forEach((file: Document) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'handicappedWithMonthlyAllowance':
        this.documents.handicapMonthlyAllowanceFiles.forEach((file: Document) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'inhabitantSettlement':
        this.inhabitantSettlementDate = null;
        this.form101Data.inhabitantSettlementDate = '';
        this.form101Data.settlement = null;
        this.documents.settlementFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'immigrant':
        this.immigrationOrReturningDate = null;
        this.noIncomeUntilDate = null;
        this.form101Data.immigrationOrReturningDate = null;
        this.form101Data.noIncomeUntilDate = null;
        this.form101Data.immigrant = null;
        this.form101Data.newImmigrantType = null;
        this.documents.immigrantFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'childrenCustody':
        this.form101Data.childrenCustody0Count = null;
        this.form101Data.childrenCustody0 = null;
        this.form101Data.childrenCustody1To2Count = null;
        this.form101Data.childrenCustody1To2 = null;
        this.form101Data.childrenCustody3Count = null;
        this.form101Data.childrenCustody3 = null;
        this.form101Data.childrenCustody4To5Count = null;
        this.form101Data.childrenCustody4To5 = null;
        this.form101Data.childrenCustody6To17Count = null;
        this.form101Data.childrenCustody6To17 = null;
        this.form101Data.childrenCustody18Count = null;
        this.form101Data.childrenCustody18 = null;
        break;
      case 'infants':
        this.form101Data.infants0Count = null;
        this.form101Data.infants0 = null;
        this.form101Data.infants1To2 = null;
        this.form101Data.infants1To2Count = null;
        this.form101Data.infants3 = null;
        this.form101Data.infants3Count = null;
        this.form101Data.infants4To5 = null;
        this.form101Data.infants4To5Count = null;
        this.form101Data.infants6To17Count = null;
        this.form101Data.infants6To17 = null;
        break;
      case 'unemployedPartner':
        this.documents.unemployedPartnerFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'noneCustody':
        this.documents.nonCustodyFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'incompetentChild':
        this.documents.incompetentChildFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'childSupport':
        this.documents.childSupportFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'dischargedSoldier':
        this.serviceBeginDate = null;
        this.serviceEndDate = null;
        this.form101Data.serviceBeginDate = null;
        this.form101Data.serviceEndDate = null;
        this.documents.soldierFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'academicGraduate':
        this.documents.academicFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'reserveService':
        this.form101Data.reserveServiceCount = null;
        this.documents.reserveFiles.forEach((file) => {
          this.onRemovedClicked(file);
        });
        break;
      case 'taxCoordinate':
        if (newVal !== 1) {
          this.documents.taxCoordsNoIncomeFiles.forEach((file) => {
            this.onRemovedClicked(file);
          });
        }
        if (newVal !== 3) {
          this.documents.taxCoordsApprovedFiles.forEach((file) => {
            this.onRemovedClicked(file);
          });
        }
        break;
    }
  }

  public updateDate(date: Date, property: any) {
    this.updateForm101Data(date ? Utils.dateToString(date) : date, property);
  }

  public updateSelectedSettlementCity(city: City) {
    this.updateForm101Data(city.description, 'settlement');
  }


  public open802FileDialog() {
    this.upload802FileModal = true;
  }

  public close802FileDialog() {
    this.upload802FileModal = false;
  }

  public open8022FileDialog() {
    this.upload8022FileModal = true;
  }

  public close8022FileDialog() {
    this.upload8022FileModal = false;
  }

  public open803FileDialog() {
    this.upload803FileModal = true;
  }

  public close803FileDialog() {
    this.upload803FileModal = false;
  }

  public open804FileDialog() {
    this.upload804FileModal = true;
  }

  public close804FileDialog() {
    this.upload804FileModal = false;
  }

  public open805FileDialog() {
    this.upload805FileModal = true;
  }

  public close805FileDialog() {
    this.upload805FileModal = false;
  }

  public open809FileDialog() {
    this.upload809FileModal = true;
  }

  public close809FileDialog() {
    this.upload809FileModal = false;
  }

  public open810FileDialog() {
    this.upload810FileModal = true;
  }

  public close810FileDialog() {
    this.upload810FileModal = false;
  }

  public open811FileDialog() {
    this.upload811FileModal = true;
  }

  public close811FileDialog() {
    this.upload811FileModal = false;
  }

  public open813FileDialog() {
    this.upload813FileModal = true;
  }

  public close813FileDialog() {
    this.upload813FileModal = false;
  }

  public open814FileDialog() {
    this.upload814FileModal = true;
  }

  public close814FileDialog() {
    this.upload814FileModal = false;
  }

  public open851FileDialog() {
    this.upload851FileModal = true;
  }

  public close851FileDialog() {
    this.upload851FileModal = false;
  }

  public open901FileDialog() {
    this.upload901FileModal = true;
  }


  public close901FileDialog() {
    this.upload901FileModal = false;
  }

  public open902FileDialog() {
    this.upload902FileModal = true;
  }


  public close902FileDialog() {
    this.upload902FileModal = false;
  }

  public close903FileDialog() {
    this.upload903FileModal = false;
  }

  public open903FileDialog() {
    this.upload903FileModal = true;
  }

  public open816FileDialog() {
    this.upload816FileModal = true;
  }

  public close816FileDialog() {
    this.upload816FileModal = false;
  }


  public openDeleteDialog(index: number, files: any[]) {
    if (files[index].docId) {
      this.$root.$emit('openDeleteFileDialog', files[index]);
    }
  }

  public onUploadClicked(inputFile: InputFile, docType: number) {
    this.uploadClicked({
      requestBody: {
        inputFile,
        docType,
        formId: this.form101Data.formId,
      },
    });
  }

  public onDownloadClicked(file: InputFile) {
    if (this.managerMode) {
      this.managerDownloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        },
      });
    } else {
      this.downloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
        },
      });
    }
  }

  public onRemovedClicked(file: Document) {
    this.deleteDocument(file.docId);
  }

  private autoFill(): void {
    const notMarriage = +this.form101Data.maritalStatus !== MaritalStatus.MARRIED;
    const isSingle = +this.form101Data.maritalStatus === MaritalStatus.SINGLE;
    const isMarried = +this.form101Data.maritalStatus === MaritalStatus.MARRIED;
    const isDivorce = +this.form101Data.maritalStatus === MaritalStatus.DIVORCEE;
    const isWidower = +this.form101Data.maritalStatus === MaritalStatus.WIDOWER;
    const isSeparated = +this.form101Data.maritalStatus === MaritalStatus.SEPARATED;
    const isMale = +this.form101Data.gender === Gender.MALE;
    const isFemale = +this.form101Data.gender === Gender.FEMALE;

    const hasChildren = this.form101Data.children.length > 0;
    const hasChildCustodyWithPay = hasChildren && this.hasChildCustodyWithPay();
    const hasChildCustody = hasChildren && this.hasChildCustody();
    const childNoUnderCustody = hasChildren && this.childNoUnderCustody();
    const allChildUnderCustodyNoPay = hasChildren && this.allChildUnderCustodyNoPay();
    const doesntHaveChildCustodyWithPay = !hasChildCustodyWithPay;

    // section 1 - form101Data.isrResident
    this.updateForm101Data(true, 'exemptCitizenship');

    // section 6 - form101Data.separatedParent
    this.updateForm101Data(((notMarriage && hasChildCustodyWithPay) || (isWidower && hasChildCustody)) || false,
        'separatedPartner');

    // section 7 - form101Data.childrenCustody
    if (hasChildCustody &&
        ((notMarriage && hasChildCustodyWithPay) ||
            (isFemale && isMarried && hasChildren) ||
            (isWidower && hasChildCustody) ||
            (isFemale && (isDivorce || isSeparated) && allChildUnderCustodyNoPay))) {
      this.updateForm101Data(true, 'childrenCustody');
      this.countChild(7);
    } else {
      this.updateForm101Data(false, 'childrenCustody');
    }

    // section 8 - form101Data.infants --- old
    if (hasChildren && ((isMale && isMarried) ||
        (isFemale && notMarriage && childNoUnderCustody) ||
        (isWidower) ||
        (isMale && notMarriage && doesntHaveChildCustodyWithPay) ||
        (isFemale && isSingle && allChildUnderCustodyNoPay))) {
      this.countChild(8);
      if ((this.form101Data.infants0Count && this.form101Data.infants0Count > 0) ||
          (this.form101Data.infants1To2Count && this.form101Data.infants1To2Count > 0) ||
          (this.form101Data.infants3Count && this.form101Data.infants3Count > 0) ||
          (this.form101Data.infants4To5Count && this.form101Data.infants4To5Count > 0) ||
          (this.form101Data.infants6To17Count && this.form101Data.infants6To17Count > 0) ) {
        this.updateForm101Data(true, 'infants');
      }
    } else {
      this.updateForm101Data(false, 'infants');
    }

    // section 9 - form101Data.singularParent
    this.updateForm101Data((isWidower && hasChildCustody) || false, 'singularParent');

    // section 13 - form101Data.bagir
    this.updateForm101Data(((this.employeeAge >= 16 && this.employeeAge <= 18) ||
        (this.partnerAge >= 16 && this.partnerAge <= 18)) || false, 'adolescent');

    //

  }

  private countChild(section: number) {
    if (section === 7) {
      this.updateForm101Data(0, 'childrenCustody0Count');
      this.updateForm101Data(0, 'childrenCustody1To2Count');
      this.updateForm101Data(0, 'childrenCustody3Count');
      this.updateForm101Data(0, 'childrenCustody4To5Count');
      this.updateForm101Data(0, 'childrenCustody6To17Count');
      this.updateForm101Data(0, 'childrenCustody18Count');
      this.updateForm101Data(false, 'childrenCustody0');
      this.updateForm101Data(false, 'childrenCustody1To2');
      this.updateForm101Data(false, 'childrenCustody3');
      this.updateForm101Data(false, 'childrenCustody4To5');
      this.updateForm101Data(false, 'childrenCustody6To17');
      this.updateForm101Data(false, 'childrenCustody18');
    }
    if (section === 8) {
      this.updateForm101Data(0, 'infants0Count');
      this.updateForm101Data(0, 'infants1To2Count');
      this.updateForm101Data(0, 'infants3Count');
      this.updateForm101Data(0, 'infants4To5Count');
      this.updateForm101Data(0, 'infants6To17Count');
      this.updateForm101Data(false, 'infants0');
      this.updateForm101Data(0, 'infants1To2');
      this.updateForm101Data(0, 'infants3');
      this.updateForm101Data(0, 'infants4To5');
      this.updateForm101Data(false, 'infants6To17');
    }
    let infants6To17Count = 0;
    let infants4To5Count = 0;
    let infants3Count = 0;
    let infants1To2Count = 0;
    let infants0Count = 0;
    let childrenCustody0Count = 0;
    let childrenCustody1To2Count = 0;
    let childrenCustody3Count = 0;
    let childrenCustody4To5Count = 0;
    let childrenCustody6To17Count = 0;
    let childrenCustody18Count = 0;
    for (const child of this.form101Data.children) {
      if (child.childBirthDate) {
        const year = Number(child.childBirthDate!.toString().substring(0, 4));
        const sum = this.form101Data.taxYear - year;
        if (sum === 0) {
          if (section === 7 && child.childCustody) {
            childrenCustody0Count++;
            this.updateForm101Data(true, 'childrenCustody0');
          } else if (section === 8) {
            infants0Count++;
            this.updateForm101Data(true, 'infants0');
          }
        }
        if (sum > 0 && sum < 3) {
          if (section === 7 && child.childCustody) {
            childrenCustody1To2Count++;
            this.updateForm101Data(true, 'childrenCustody1To2');
          } else if (section === 8) {
            infants1To2Count++;
            this.updateForm101Data(true, 'infants1To2');
          }
        }
        if (sum === 3) {
          if (section === 7 && child.childCustody) {
            childrenCustody3Count++;
            this.updateForm101Data(true, 'childrenCustody3');
          } else if (section === 8) {
            infants3Count++;
            this.updateForm101Data(true, 'infants3');
          }
        }
        if (sum > 3 && sum < 6) {
          if (section === 7 && child.childCustody) {
            childrenCustody4To5Count++;
            this.updateForm101Data(true, 'childrenCustody4To5');
          } else if (section === 8) {
            infants4To5Count++;
            this.updateForm101Data(true, 'infants4To5');
          }
        }
        if (sum > 5 && sum < 18) {
          if (section === 7 && child.childCustody) {
            childrenCustody6To17Count++;
            this.updateForm101Data(true, 'childrenCustody6To17');
          } else if (section === 8) {
            infants6To17Count++;
            this.updateForm101Data(true, 'infants6To17');
          }
        }
        if (section === 7 && sum === 18 && child.childCustody) {
          childrenCustody18Count++;
          this.updateForm101Data(true, 'childrenCustody18');
        }
      }
    }
    if (section === 7) {
      this.updateForm101Data(childrenCustody0Count || null, 'childrenCustody0Count');
      this.updateForm101Data(childrenCustody1To2Count || null, 'childrenCustody1To2Count');
      this.updateForm101Data(childrenCustody3Count || null, 'childrenCustody3Count');
      this.updateForm101Data(childrenCustody4To5Count || null, 'childrenCustody4To5Count');
      this.updateForm101Data(childrenCustody6To17Count || null, 'childrenCustody6To17Count');
      this.updateForm101Data(childrenCustody18Count || null, 'childrenCustody18Count');
    }
    if (section === 8) {
      this.updateForm101Data(infants6To17Count || null, 'infants6To17Count');
      this.updateForm101Data(infants4To5Count || null, 'infants4To5Count');
      this.updateForm101Data(infants3Count || null, 'infants3Count');
      this.updateForm101Data(infants1To2Count || null, 'infants1To2Count');
      this.updateForm101Data(infants0Count || null, 'infants0Count');
    }
  }

  private hasChildCustodyWithPay(): boolean {
    for (const child of this.form101Data.children) {
      if (child.childCustody && child.childPay) {
        return true;
      }
    }
    return false;
  }

  private hasChildCustody(): boolean {
    for (const child of this.form101Data.children) {
      if (child.childCustody) {
        return true;
      }
    }
    return false;
  }

  private childNoUnderCustody(): boolean {
    let count = 0;
    for (const child of this.form101Data.children) {
      if (!child.childCustody) {
        count++;
      }
    }
    return (count > 0);
  }

  private allChildUnderCustodyNoPay(): boolean {
    let count = 0;
    for (const child of this.form101Data.children) {
      if (child.childCustody && !child.childPay) {
        count++;
      } else {
        return false;
      }
    }
    return (this.form101Data.children.length === count);
  }

  get childCustodyRequired(): boolean {
    return this.form101Data.childrenCustody &&
        (!this.form101Data.childrenCustody0Count && !this.form101Data.childrenCustody1To2Count
            && !this.form101Data.childrenCustody3Count && !this.form101Data.childrenCustody4To5Count
            && !this.form101Data.childrenCustody6To17Count && !this.form101Data.childrenCustody18Count);
  }

  get infantRequired(): boolean {
    return this.form101Data.infants &&
        (!this.form101Data.infants0Count && !this.form101Data.infants1To2Count
            && !this.form101Data.infants3Count && !this.form101Data.infants4To5Count
            && !this.form101Data.infants6To17Count);
  }

  get serviceBeginDateTo(): Date {
    return new Date(this.serviceBeginDate);
  }

  get getTaxCoordsRadios(): Array<any> {
    return this.form101MetaData.displayExternalIncomeFlag ? this.mockData.taxDetails.taxCoordsRadios : this.mockData.taxDetails.taxCoordsRadios.filter( item => item.value !== 2 );
  }

  get showInfantValidationMessage(): boolean {
    let childUnder18 = false;
    if (this.form101Data.children.length > 0) {
      for (const child of this.form101Data.children) {
        if (child.childBirthDate) {
          const year = Number(child.childBirthDate!.toString().substring(0, 4));
          const childAge = this.form101Data.taxYear - year;
          if (childAge >= 0 && childAge < 18) {
            childUnder18 = true;
          }
        }
      }
    }
    return this.form101Data.infants
        && !childUnder18
        && (!(this.form101Data.gender === Gender.MALE
            && this.form101Data.maritalStatus === MaritalStatus.MARRIED)
            && !(this.form101Data.maritalStatus !== MaritalStatus.MARRIED
                && this.form101Data.childrenCustody)
            && !(this.form101Data.maritalStatus === MaritalStatus.WIDOWER)
            && !(this.form101Data.gender === Gender.FEMALE
                && this.form101Data.maritalStatus !== MaritalStatus.MARRIED
                && this.form101Data.children.length > 0 && !this.hasChildCustodyWithPay())
            && !this.form101Data.singularParent);
  }

}
